import { useEffect, useState, useRef } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { usePrepareCart } from '../../../hooks/usePrepareCart'
import { FaCheckCircle } from 'react-icons/fa'
import { CLASS_WITHOUT_SHIPPING, BRANDS_WITH_REQUIRED_FREIGHT } from '../../../utils/constants'

export default function PagaleveSuccess() {
  const history = useHistory()
  const location = useLocation()
  const { clearCart, lastOrderCreated } = usePrepareCart()
  const [countdown, setCountdown] = useState(3)
  const hasRedirected = useRef(false)

  useEffect(() => {
    if (hasRedirected.current) {
      return undefined
    }

    const params = new URLSearchParams(location.search)
    const orderId = params.get('order_id')
    const status = params.get('status')

    // eslint-disable-next-line no-console
    console.log('Pagaleve Success - Params:', { orderId, status })

    if (status === 'paid' && orderId) {
      hasRedirected.current = true

      const clearCartTimeout = setTimeout(() => {
        clearCart()
      }, 1000)

      const hasItems = lastOrderCreated?.items && lastOrderCreated.items.length > 0
      const isAllSupplements = hasItems
        ? lastOrderCreated.items.every(
            (item: any) =>
              CLASS_WITHOUT_SHIPPING.includes(item?.product?.class_id || item?.class_id) &&
              !BRANDS_WITH_REQUIRED_FREIGHT.includes(item?.product?.brand_id || item?.brand_id)
          )
        : false

      const countdownInterval = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(countdownInterval)
            return 0
          }
          return prev - 1
        })
      }, 1000)

      // Redireciona após 3 segundos
      const redirectTimeout = setTimeout(() => {
        const redirectUrl = isAllSupplements ? `/detalhes-do-pedido/${orderId}` : `/enviar-receita/${orderId}`
        // eslint-disable-next-line no-console
        console.log('Pagaleve Success - Redirecionando para:', redirectUrl)
        history.push(redirectUrl)
      }, 3000)

      return () => {
        clearInterval(countdownInterval)
        clearTimeout(redirectTimeout)
        clearTimeout(clearCartTimeout)
      }
    }

    // Se não tiver os params corretos, redireciona para home
    if (!status || !orderId) {
      hasRedirected.current = true
      const redirectTimeout = setTimeout(() => {
        history.push('/')
      }, 3000)

      return () => {
        clearTimeout(redirectTimeout)
      }
    }

    return undefined
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search])

  const params = new URLSearchParams(location.search)
  const orderId = params.get('order_id')

  return (
    <div className="min-h-screen bg-gray-50 px-4 py-8">
      <div className="mx-auto w-full max-w-md rounded-xl bg-white p-8 text-center shadow-lg">
        <div className="mb-6 flex justify-center">
          <FaCheckCircle className="h-20 w-20 text-green-500" />
        </div>

        <h1 className="mb-4 text-3xl font-bold text-gray-800">Pagamento Aprovado!</h1>

        <p className="mb-2 text-lg text-gray-600">
          Seu pagamento via <span className="font-semibold text-primary-700">PIX Parcelado</span> foi confirmado com
          sucesso!
        </p>

        {orderId && (
          <div className="my-6 rounded-lg bg-gray-100 p-4">
            <p className="text-sm text-gray-600">Número do Pedido</p>
            <p className="text-xl font-bold text-gray-800">#{orderId}</p>
          </div>
        )}

        <div className="mt-6">
          <div className="mx-auto h-2 w-full overflow-hidden rounded-full bg-gray-200">
            <div
              className="h-full bg-green-500 transition-all duration-1000 ease-linear"
              style={{ width: `${((3 - countdown) / 3) * 100}%` }}
            />
          </div>
          <p className="mt-3 text-sm text-gray-500">Redirecionando em {countdown} segundos...</p>
        </div>

        <div className="mt-6 text-xs text-gray-400">
          <p>Você receberá um e-mail com os detalhes do seu pedido.</p>
        </div>
      </div>
    </div>
  )
}
